"use client";

import { useTranslation } from "react-i18next";
import ChannelPost from "./ChannelPost";
import "./ChannelPostFeed.css";

const ChannelPostFeed = ({ posts, channel, userRole, onPostsUpdate, onChannelUpdated, onEditPost, onDeletePost }) => {
  const { t } = useTranslation();

  if (!posts || posts.length === 0) {
    return (
      <div className="channel-post-feed-empty">
        <div className="channel-post-feed-empty-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
        <h3>{t("channelPostFeed.emptyTitle", "No posts yet")}</h3>
        <p>
          {t(
            "channelPostFeed.emptySubtitle",
            "Be the first to share something in this channel!"
          )}
        </p>
      </div>
    );
  }

  // Helper function to normalize post IDs for comparison
  const normalizePostId = (id) => {
    const numeric = Number(id);
    return Number.isNaN(numeric) ? id : numeric;
  };

  // Helper function to check if a post is pinned
  const isPostPinned = (post) => {
    if (!post) return false;
    // Check post flags
    if (post.isPinned || post.is_pinned || post.pinned) return true;
    // Check against channel's pinned post IDs
    const pinnedPostIds = Array.isArray(channel?.pinnedPostIds)
      ? channel.pinnedPostIds
      : [];
    const postId = normalizePostId(post.id);
    return pinnedPostIds.some(
      (pinnedId) => normalizePostId(pinnedId) === postId
    );
  };

  // Sort posts: pinned posts first (by created_at descending), then non-pinned posts (by created_at descending)
  const sortedPosts = [...posts].sort((a, b) => {
    const aIsPinned = isPostPinned(a);
    const bIsPinned = isPostPinned(b);

    // If one is pinned and the other isn't, pinned post comes first
    if (aIsPinned && !bIsPinned) return -1;
    if (!aIsPinned && bIsPinned) return 1;

    // If both are pinned or both are not pinned, sort by date (newest first)
    const dateA = new Date(a.created_at || a.createdAt || 0);
    const dateB = new Date(b.created_at || b.createdAt || 0);
    return dateB - dateA; // Descending order (newest first)
  });

  return (
    <div className="channel-post-feed">
      {sortedPosts.map(post => (
        <ChannelPost
          key={post.id}
          post={post}
          channel={channel}
          userRole={userRole}
          onEditPost={onEditPost}
          onDeletePost={onDeletePost}
          onChannelPinnedChange={onChannelUpdated}
          onUpdate={(updatedPost) => {
            if (onPostsUpdate) {
              onPostsUpdate(prevPosts => 
                prevPosts.map(p => p.id === updatedPost.id ? updatedPost : p)
              );
            }
          }}
        />
      ))}
    </div>
  );
};

export default ChannelPostFeed;

